import React, { useState } from 'react';

function QuadrantTracking({ settings, updateSetting }) {
    const [selectedShape, setSelectedShape] = useState("");
    const gridSize = 5; // 5x5 matrix

    const handleShapeChange = (e) => {
        const value = e.target.value;
        setSelectedShape(value);
        updateSetting("shape", value);
    };

    const handleButtonClick = (row, col) => {
        const numRows = 4;
        const numCols = 4;
        const screenWidth = 2800;
        const screenHeight = 1360;

        const screenX = (col / numCols) * screenWidth;
        const screenY = (row / numRows) * screenHeight;

        const coordinates = { x: screenX, y: screenY };
        updateSetting("coordinates", coordinates);
    };

    return (
        <div className="ts-exam-control-stack">
            <div className="ts-exam-inline-field ts-exam-inline-field-stack">
            <label htmlFor="quadrant-shape">Select Quadrant Shape</label>
            <select
              id="quadrant-shape"
              className="ts-input"
              onChange={handleShapeChange}
              value={selectedShape}
            >
            <option value="" disabled>
                Select
            </option>
            <option value="circle">Circle</option>
            <option value="star">Star</option>
            <option value="square">Square</option>
            </select>
            </div>

            <h1 className="ts-exam-side-label">Button Matrix</h1>
            <div style={styles.matrix}>
                {[...Array(gridSize)].map((_, row) => (
                    <div key={row} style={styles.row}>
                        {[...Array(gridSize)].map((_, col) => (
                            <button
                                key={col}
                                style={styles.button}
                                onClick={() => handleButtonClick(row, col)}
                            >
                                {row + 1},{col + 1}
                            </button>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    matrix: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: "10px"
    },
    row: {
        display: 'flex',
    },
    button: {
        backgroundColor: 'blue',
        color: 'white',
        border: '1px solid #ddd',
        fontSize: 16,
        width: 40,
        height: 40,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
};

export default QuadrantTracking;
